export { default } from "./RuleList";
